export const BRAND_NAME = '6Ball';
// Note: It is the main site url. Ex - krishna365.com, etc.
export const BRAND_DOMAIN = '6ball.com';
// Note: It is the main site url. Ex - krishna365.com, etc.
export const BRAND_DOMAIN_SKIN_URL = '6ball.com';
export const PROVIDER = 'BetFair';
export const PROVIDER_ID = 'BetFair';
export const BACKEND_DOMAIN = 'krna79.com';